import { render } from "./speechList.vue?vue&type=template&id=72135928&scoped=true"
import script from "./speechList.vue?vue&type=script&lang=js"
export * from "./speechList.vue?vue&type=script&lang=js"

import "./speechList.vue?vue&type=style&index=0&id=72135928&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72135928"]])

export default __exports__